<template>
  <ModalDialog
    ref="dialog"
    title="Cancel Payment Received"
    icon="fa-times-circle"
    :showFooter="true"
    :submitting="submitting"
    closeTitle="Cancel"
    submitTitle="Update"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <NotificationBar type="warning">
        <NotificationBarTitle>This will cancel the payment and cannot be undone</NotificationBarTitle>
        <ul>
          <li>All invoice allocations will be cancelled and any paid invoices will be reverted to unpaid</li>
          <li>All linked overpayments will be cancelled</li>
          <li>All linked Prepaid / COD orders will <strong>NOT</strong> have their status reverted to pending payment statuses</li>
        </ul>

        <template v-if="hasXeroIntegration">
          <strong>Xero Users</strong>
          <ul>
            <li>After cancelling, please access Xero to ensure payment and any invoice allocations linked to this payment have been cancelled too.</li>
            <li>Overpayments <strong>cannot</strong> be automatically cancelled. You must access Xero to remove / refund any overpayments associated with this payment.</li>
          </ul>
        </template>
          
        
      </NotificationBar>
      
      <FormRow label="Cancellation Reason">
        <FormInputTextArea ref="textEntryArea" v-model="cancelReason" placeholder="Enter reason and details for payment cancellation" field="reason" />
      </FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { PaymentTypes, PaymentTypeLookup } from '@/store/types'

export default {
  name: 'PaymentReceivedCancelDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    paymentReceivedId: Number
  },
  data() {
    return {
      form: {},
      submitting: false,
      cancelReason: ''
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.form = this.clearFormResponse()
      this.submitting = true

      var updateData = {
        reason: this.cancelReason
      }

      this.$apiService.accountsService.cancelPaymentReceived(this.paymentReceivedId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>